import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { SevBadge } from "./Bits";
import { SEV } from "../lib/summary";

export default function FloatingSummary({ ins, summary, onOpenDefect, children }) {
  const [sev, setSev] = useState(null);
  const list = (ins.defects || []).filter((d) => !sev || sev === "ALL" || d.severity === sev);
  const open = (k) => setSev(k);
  return (
    <>
      <div className="fixed inset-x-0 bottom-0 z-30 border-t border-slate-800 bg-slate-900/95 text-white backdrop-blur-md" data-testid="floating-defect-summary">
        <div className="mx-auto flex max-w-5xl items-center gap-2 px-3 py-2.5">
          {["MAJOR", "MINOR", "COSMETIC"].map((k) => (
            <button key={k} onClick={() => open(k)} data-testid={`summary-count-${k.toLowerCase()}`} className="tap flex flex-col items-center rounded-md px-2.5 py-1 hover:bg-slate-800">
              <span className="font-display text-xl font-extrabold leading-none" style={{ color: SEV[k].hex === "#2563EB" ? "#60A5FA" : SEV[k].hex === "#D97706" ? "#FBBF24" : "#F87171" }}>{summary.counts[k] || 0}</span>
              <span className="font-mono text-[9px] tracking-widest text-slate-400">{k === "COSMETIC" ? "COSM" : k}</span>
            </button>
          ))}
          <button onClick={() => open("ALL")} className="tap hidden flex-col items-center rounded-md px-2.5 py-1 hover:bg-slate-800 sm:flex" data-testid="summary-count-total">
            <span className="font-display text-xl font-extrabold leading-none">{summary.total}</span><span className="font-mono text-[9px] tracking-widest text-slate-400">TOTAL</span>
          </button>
          <div className="ml-auto flex items-center gap-2">{children}</div>
        </div>
      </div>
      <Sheet open={!!sev} onOpenChange={(v) => !v && setSev(null)}>
        <SheetContent side="bottom" className="max-h-[75vh] overflow-y-auto" data-testid="summary-defects-sheet">
          <SheetHeader><SheetTitle className="font-display">{sev === "ALL" ? "All observations" : `${SEV[sev]?.label} defects`} · {list.length}</SheetTitle></SheetHeader>
          <div className="mt-4 space-y-2">
            {list.map((d) => (
              <button key={d.defect_id} onClick={() => { setSev(null); onOpenDefect(d); }} className="tap flex w-full items-center gap-3 rounded-md border border-slate-200 p-3 text-left hover:border-slate-400" data-testid={`summary-defect-${d.number}`}>
                <span className="font-mono text-xs font-bold">{d.number}</span>
                <span className="flex-1"><span className="block text-sm font-semibold">{d.name}</span><span className="text-xs text-slate-500">{d.room} · {d.category}</span></span>
                <SevBadge sev={d.severity} />
              </button>
            ))}
            {!list.length && <p className="text-sm text-slate-500">None recorded yet.</p>}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
